// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  PROJECT_STATUS_LABELS,
  ProjectStatus,
} from '@/constants/project-status';
import { Chip, ChipProps } from '@mui/material';

const COLORS: Record<ProjectStatus, ChipProps['color']> = {
  ACTIVE: 'success',
  PAST: 'default',
  UPCOMING: 'info',
  DATE_RANGE_INCOMPLETE: 'success',
};

const VARIANTS: Record<ProjectStatus, ChipProps['variant']> = {
  ACTIVE: 'filled',
  PAST: 'filled',
  UPCOMING: 'filled',
  DATE_RANGE_INCOMPLETE: 'outlined',
};

interface Props {
  status: ProjectStatus;
}

export function ProjectStatusChip(props: Props) {
  const variant = VARIANTS[props.status];
  const color = COLORS[props.status];

  const label = PROJECT_STATUS_LABELS[props.status];

  return <Chip size="small" label={label} variant={variant} color={color} />;
}
